export default {
  generalInfo: '{step}. Datos generales',
  introductoryContent: '{step}. Contenido introductorio',
  triggers: '{step}. Disparadores',
  classes: '{step}. Clases',
  exitWithoutSave: 'Continuar sin guardar',
  exitWithoutSaveDesc: 'No has guardado los cambios ¿Estás seguro que quieres continuar?',
  confirmExit: 'Continuar'
}
export const en = {
  generalInfo: '{step}. General data',
  introductoryContent: '{step}. Introductory content',
  triggers: '{step}. Triggers',
  classes: '{step}. Classes',
  exitWithoutSave: 'Continue without saving',
  exitWithoutSaveDesc: 'You have not saved your changes. Are you sure you want to continue?',
  confirmExit: 'Continue'
}
export const ca = {
  generalInfo: '{step}. Dades generals',
  introductoryContent: '{step}. Contingut introductori',
  triggers: '{step}. Disparadors',
  classes: '{step}. Classes',
  exitWithoutSave: 'Continuar sense desar',
  exitWithoutSaveDesc: 'No has desat els canvis. Estàs segur que vols continuar?',
  confirmExit: 'Continuar'
}
